"use strict";

exports.implementation = class NavigatorLanguageImpl {
  get language() {
    return "en-US";
  }

  // See Navigator constructor for languages
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/navigator/NavigatorLanguage-impl.js
// module id = PBPi
// module chunks = 0